/* The TeeJay Studios — lightweight wishlist (stored in this browser) */
(function () {
  if (window.TJWishlist) return;
  var KEY = 'tj_wishlist';
  var mem = [];
  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return mem.slice(); }
  }
  function write(list) {
    mem = list.slice();
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('tj:wishlist', { detail: { items: list } }));
  }
  var api = {
    items: read,
    has: function (h) { return read().indexOf(h) > -1; },
    add: function (h) { var l = read(); if (l.indexOf(h) < 0) { l.unshift(h); write(l); } },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); },
    toggle: function (h) { api.has(h) ? api.remove(h) : api.add(h); return api.has(h); }
  };
  window.TJWishlist = api;

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.4 8 3.4 4.5 6.9 4.5c2 0 3.6 1.1 5.1 3 1.5-1.9 3.1-3 5.1-3 3.5 0 5.5 3.5 4.2 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';

  function handleFromHref(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function syncButtons() {
    var list = read();
    document.querySelectorAll('[data-tj-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-tj-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
    document.querySelectorAll('[data-tj-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }

  function decorateCards(root) {
    (root || document).querySelectorAll('.card-wrapper.product-card-wrapper, .card-wrapper').forEach(function (card) {
      if (card.querySelector('[data-tj-wish]')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var inner = card.querySelector('.card__inner');
      if (!link || !inner) return;
      var h = handleFromHref(link.getAttribute('href'));
      if (!h) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tj-wish-btn';
      b.setAttribute('data-tj-wish', h);
      b.innerHTML = HEART;
      inner.appendChild(b);
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-tj-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = api.toggle(b.getAttribute('data-tj-wish'));
    b.classList.remove('is-pop'); void b.offsetWidth; if (on) b.classList.add('is-pop');
  }, true);

  document.addEventListener('tj:wishlist', syncButtons);
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncButtons(); });

  function init() {
    decorateCards();
    syncButtons();
    if ('MutationObserver' in window) {
      var t;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { decorateCards(); syncButtons(); }, 120); })
        .observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
